import React from 'react';
import { useState } from 'react'
import ShoppingListForm from "../../ShoppingListForm/ShoppingListForm"
import { useData } from "../../../DataContext/DataProvider"

/**
 * Used in: ../ShoppingList
 * @param initialData: {
 *  Item_ID: int
 * Item_Name: string
 * Item_Quantity: int
 * Item_Recipe_Plan: (Plan_ID) can be null
 * Plan_Date: int, can be null
 * Recipe_Name: string, can be null
 * Item_Recipe_Plan_Ingredient: (Recipe_Ingredient_ID) can be null
 *  }
 * @param editItem function to enter edit item mode
 * @param deleteItem function to delete item
 * @returns a list element within the shopping list, with both read-only and editable modes
 */
function ShoppingListElement({ initialData}) {
    const [editing, setEditing] = useState(false);

    const dataContext = useData();
        
    const deleteHandler = (e) => {
        e.preventDefault();
        dataContext.shoppingListData.deleteShoppingListItem(initialData)
    }

    const buyItemHandler = (e) => {
        e.preventDefault();
        dataContext.shoppingListData.buyShoppingListItem(initialData)
    }

    return (
        <li className={!editing ? "hoverable-element" : "visible-element"}>
            <div className={!editing ? "columns replacable-element visible" : "columns replacable-element invisible" }>
                <p>{initialData?.Item_Name ?? "Unknown Item"}</p>
                <p>{initialData?.Item_Quantity ?? "Unknown Quantity"}g</p>
                {initialData?.Recipe_Name ? <p className="small-text">For {initialData?.Recipe_Name ?? "Unknown Recipe"} on {new Date(initialData?.Plan_Date).toLocaleDateString()}</p> : null}
                <div>
                    <button className="button" onClick={deleteHandler}>Delete</button>
                    <button className="button" onClick={() => setEditing(true)}>Edit</button>
                    <button className="button" onClick={buyItemHandler}>Buy Item</button>
                </div>
            </div>
            <div className={editing ? "replacable-element visible" : "replacable-element invisible"}>
                <ShoppingListForm initialItem={initialData} setEditing={setEditing} />
            </div>
        </li>
    )
}

export default ShoppingListElement